import { useFormSelector } from 'mrf/redux/ReduxHelper';
import FormCRUD from 'mrf/view/FormCRUD';
import { Col, Grid } from 'mrf/view/Grid';
import TextField from 'mrf/view/TextField';
import React from 'react';

export default function CountryForm({ history, match }) {

    const context = useFormSelector({
        id: match?.params?.id,
        resource: 'countries',
        endpoint: `/api/countries/${match?.params?.id}`
    });

    return <FormCRUD
        title='Country'
        match={match}
        history={history}
        context={context}
    >
        <Grid>
            <Col size={9}>
                <TextField
                    label='Name'
                    field='name'
                />
            </Col>
            <Col size={3}>
                <TextField
                    label='Abbreviation'
                    field='abbreviation'
                />
            </Col>
        </Grid>
    </FormCRUD>
}